import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FontSizes, Stack } from '@fluentui/react';
import { chain, map } from 'lodash';
import { FeaturePanelToggle } from './FeaturePanelToggle';
/**
 * Lister control that renders out passed features as toggle controls.
 */
export const FeaturePanelToggleList = ({ featureList, }) => {
    /** The feature list but excluding features where show-in-ui is turned off. */
    const userFeatureList = chain(featureList)
        .filter(f => f.showInFeatureToggleUI !== false)
        .value();
    if (!userFeatureList || userFeatureList.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ style: { fontSize: FontSizes.mediumPlus } }, { children: "Try new features" })), _jsx("p", { children: "Try out individual new features early." }), _jsx(Stack, Object.assign({ tokens: { childrenGap: '4px' } }, { children: map(userFeatureList, feature => (_jsx(FeaturePanelToggle, Object.assign({}, feature), `feature-panel-toggle--${feature.featureName}`))) }))] }));
};
